import React from 'react';
import { motion } from 'framer-motion';
import { Compass, Wand2, Rocket, Sparkles } from 'lucide-react';
const steps = [{
  number: 1,
  icon: Compass,
  title: 'Discovery Quest',
  description: 'We learn your goals, understand your audience, and map out the educational landscape you operate in.',
  color: 'bg-purple-500'
}, {
  number: 2,
  icon: Wand2,
  title: 'Craft & Create',
  description: 'Our team builds your custom content strategy, creates engaging materials, and prepares your campaigns.',
  color: 'bg-pink-500'
}, {
  number: 3,
  icon: Rocket,
  title: 'Launch & Level Up',
  description: 'We deploy your campaigns, engage with your audience, and continuously measure impact to optimize results.',
  color: 'bg-blue-500'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-20 px-4 bg-white" data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-104">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-105">
            Our proven three-step process to transform your educational
            marketing
          </p>
        </motion.div>

        <div className="relative" data-id="element-106">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 transform -translate-y-1/2" style={{
          top: '120px'
        }} data-id="element-107" />

          <div className="grid md:grid-cols-3 gap-8 md:gap-4" data-id="element-108">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative" data-id="element-109">
                <div className="flex flex-col items-center text-center" data-id="element-110">
                  {/* Number Circle */}
                  <motion.div whileInView={{
                scale: [0, 1.2, 1]
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.2 + 0.3
              }} className={`${step.color} w-24 h-24 rounded-full flex items-center justify-center text-white text-3xl font-bold mb-6 shadow-lg relative z-10`} data-id="element-111">
                    {step.number}
                  </motion.div>

                  {/* Icon */}
                  <div className={`${step.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-4`} data-id="element-112">
                    <step.icon size={32} className="text-white" data-id="element-113" />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-114">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-lg" data-id="element-115">{step.description}</p>
                </div>
              </motion.div>)}
          </div>

          {/* Animated Stars */}
          <motion.div initial={{
          opacity: 0,
          scale: 0
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="flex justify-center mt-12 gap-4" data-id="element-116">
            {[...Array(5)].map((_, i) => <motion.div key={i} animate={{
            y: [0, -10, 0],
            rotate: [0, 180, 360]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            delay: i * 0.2
          }} data-id="element-117">
                <Sparkles className="text-yellow-400" size={32} data-id="element-118" />
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}